import LivingObject from "../../modules/LivingObject"
import MagicParticle, { MagicParticleOptions } from "./MagicParticle"


export type FireParticleOptions = {

} & MagicParticleOptions

export default class FireParticle extends MagicParticle {

	static BASE_DAMAGE = 5
	static baseSize = 20

	constructor(options: FireParticleOptions) {
		super({
			...options,

			symbol: '🔥',
			size: 20
		})
	}


	tick(delta: number) {
		super.tick(delta)

		if (!this.isDead) {

			const colliding = this.world.findInRadius(this.position.x, this.position.y, this.size / 2)

			colliding.forEach(item => {
				if ((item !== this) && item instanceof LivingObject) {
					item.damage(FireParticle.BASE_DAMAGE * this.amp * delta)
				}
			})

			if (this.graphics) {
				this.graphics.alpha = this.getLifespanRatio()
			}
		}
	}

}